<svg:g *ngIf="config.draw">
    <svg:g #legend [style.transform]="transformLegend">
        <svg:g #legendItem
               class="legend-item"
               *ngFor="let serie of series; index as i"
               [style.transform]="'translate()'"
               (click)="toggleVisibility(serie.id)">
            <svg:circle [style.stroke]="serie.config.color"
                        [attr.cx]="0"
                        [attr.cy]="0"
                        [attr.r]="radius"
                        [style.transform]="'translate(7px)'">
            </svg:circle>
            <svg:text [style.stroke]="serie.config.color"
                      [style.textDecoration]="serie.isVisible ? '' : 'line-through'"
                      [style.transform]="'translate(21px, 4px)'">
                {{ serie.label }}
            </svg:text>
        </svg:g>
        <!-- <svg:rect x="-10" y="-14" [attr.width]="legendWidth + 20" [attr.height]="legendHeight" rx="7" /> -->
    </svg:g>
</svg:g>
